import React from "react";
import {
	Input as CoreInput,
	Select as CoreSelect
} from "@sparefoot/react-commons";

import { FormFieldWrapper } from "./FormFieldWrapper";

export const TextField = (props) => (
	<FormFieldWrapper {...props}>
		<CoreInput type="text" />
	</FormFieldWrapper>
);

export const EmailField = (props) => (
	<FormFieldWrapper {...props}>
		<CoreInput type="email" />
	</FormFieldWrapper>
);

export const PhoneField = (props) => (
	<FormFieldWrapper {...props}>
		<CoreInput type="tel" />
	</FormFieldWrapper>
);

export const SelectField = (props) => (
	<FormFieldWrapper {...props}>
		<CoreSelect />
	</FormFieldWrapper>
);
